import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { URI_APIs } from '@features/auth/const';
import { CoreAuthConfigService } from '@features/auth/core-auth-config.service';
import { Observable, of, tap } from 'rxjs';
import { StorageHelper } from '@features/auth/public-api';

@Injectable()
export class SsoCodeChallengeService {
  private readonly httpClient = inject(HttpClient);
  private readonly conf = inject(CoreAuthConfigService);

  // Xin code challenge tu server truoc khi redirect ve ung dung
  createCodeChallenge(clientId: string, redirectUri: string, token = StorageHelper.getAccessToken()): Observable<any> {
    const url = this.conf.buildURL(URI_APIs.SSO_GET_AUTHORIZE_CODE);
    const requestBody: any = {
      client_id: clientId,
      redirect_uri: redirectUri,
      token: token,
    }
    const response = this.httpClient.post<any>(url, requestBody,);

    return response.pipe(
      tap((response) => {
        StorageHelper.setSSOWebAuthorizationCode(response.authorization_code ?? '');
      })
    );
  }
}
